var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehavioralBiometrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0347 174.493C27.0347 173.966 27.0347 173.44 27.0347 172.913C27.0347 147.07 27.0496 121.228 27 95.3851C27 93.8889 27.441 93.6006 28.8334 93.6006C53.0088 93.6404 77.1892 93.6354 101.37 93.6205C102.38 93.6205 103.089 93.5161 103.089 95.0272C103.034 120.974 103.049 146.926 103.049 172.873V174.121C101.925 168.419 99.2092 163.772 94.5218 160.312C91.1425 157.812 87.1983 156.937 83.1897 156.201C82.2086 156.022 81.2176 155.843 80.2563 155.575C78.091 154.964 77.0009 153.388 76.5203 151.275C76.3766 150.654 76.6689 150.301 77.0851 149.918C79.2257 147.955 80.8064 145.594 81.7577 142.85C82.0253 142.08 82.4266 141.955 83.1302 141.896C91.2663 141.19 95.384 133.53 91.3952 126.462C90.8749 125.542 91.1474 124.831 91.4398 124.076C92.8916 120.283 93.4664 116.421 92.4754 112.42C90.5281 104.521 83.8834 98.9441 75.6928 98.7651C66.5657 98.5713 57.4287 98.5961 48.2966 98.7502C41.8749 98.8546 38.015 105.376 40.765 111.271C41.32 112.459 41.2407 113.006 40.215 113.851C37.1677 116.351 36.4442 120.442 38.337 124.21C38.9118 125.353 38.9416 126.203 38.3519 127.381C35.1113 133.858 39.5461 141.329 46.929 141.881C47.8506 141.95 48.2867 142.204 48.5988 143.089C49.4709 145.569 50.8682 147.756 52.8155 149.521C53.6529 150.281 53.7818 151.012 53.4498 152.031C52.8403 153.89 51.6957 155.162 49.7831 155.605C47.6326 156.102 45.4376 156.44 43.292 156.972C34.1104 159.248 28.9473 165.273 27.0446 174.493H27.0347Z",
    fill: "url(#paint0_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5766 72.5541C29.5766 68.2644 29.5518 63.9747 29.5766 59.6899C29.6806 43.5253 42.0929 28.6481 57.9539 25.6607C77.2982 22.0172 95.2056 33.6933 99.6997 52.895C100.195 55.0076 100.507 57.1549 100.507 59.3321C100.507 68.5974 100.493 77.8627 100.537 87.1281C100.542 88.2117 100.299 88.5745 99.1597 88.5546C94.9925 88.4851 90.8204 88.4801 86.6532 88.5546C85.4739 88.5745 85.2956 88.1471 85.3005 87.0982C85.3402 78.3648 85.3451 69.6263 85.3154 60.8879C85.2807 50.9366 78.7797 42.8394 69.1423 40.6771C57.9786 38.1719 46.4583 46.3288 45.0164 57.6917C44.6398 60.6543 44.7983 63.6118 44.7785 66.5694C44.7389 73.3991 44.7339 80.2288 44.7934 87.0585C44.8033 88.2465 44.501 88.5696 43.3118 88.5497C39.1942 88.4701 35.0766 88.4801 30.964 88.5497C29.8739 88.5646 29.532 88.2912 29.5468 87.1579C29.6113 82.2866 29.5766 77.4154 29.5766 72.5441V72.5541Z",
    fill: "url(#paint1_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.326 139.385C150.459 139.385 160.592 139.385 170.725 139.385C173.222 139.385 173.995 140.176 174 142.721C174 149.019 174 155.321 174 161.619C174 163.941 173.168 164.79 170.883 164.79C150.459 164.79 130.039 164.786 109.615 164.815C108.48 164.815 108.089 164.602 108.098 163.359C108.163 155.843 108.163 148.323 108.098 140.807C108.089 139.559 108.49 139.351 109.62 139.356C119.857 139.4 130.094 139.38 140.336 139.38L140.326 139.385ZM120.729 147.01C118.018 147.05 115.685 149.441 115.724 152.14C115.759 154.849 118.162 157.21 120.843 157.17C123.548 157.131 125.892 154.73 125.852 152.036C125.813 149.322 123.419 146.971 120.729 147.01ZM141.109 157.17C143.814 157.136 146.158 154.735 146.118 152.036C146.083 149.322 143.69 146.971 141 147.01C138.289 147.05 135.955 149.436 135.99 152.14C136.025 154.849 138.423 157.21 141.104 157.17H141.109ZM166.394 152.051C166.369 149.337 163.981 146.981 161.29 147.01C158.58 147.035 156.241 149.416 156.266 152.125C156.291 154.834 158.679 157.2 161.365 157.17C164.07 157.146 166.419 154.755 166.389 152.051H166.394Z",
    fill: "url(#paint2_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0396 174.965C54.649 174.965 44.2534 174.945 33.8627 174.99C32.5645 174.995 32.2276 174.722 32.5943 173.399C34.4375 166.754 38.7583 162.906 45.4624 161.649C47.1669 161.331 48.8863 161.037 50.571 160.635C54.0246 159.81 56.5467 157.801 57.8449 154.441C58.2116 153.497 58.5386 153.288 59.5395 153.646C63.236 154.958 66.9869 154.943 70.6883 153.661C71.5802 153.353 71.927 153.467 72.2838 154.377C73.691 157.966 76.3667 160.023 80.1375 160.719C82.1046 161.082 84.0668 161.48 86.0092 161.947C92.1088 163.428 95.8448 167.34 97.5543 173.325C97.921 174.612 97.6336 175.005 96.2066 174.995C85.8159 174.93 75.4253 174.96 65.0297 174.96L65.0396 174.965Z",
    fill: "url(#paint3_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.724 55.5946C153.699 65.4515 145.722 73.33 135.812 73.2853C126.08 73.2405 118.236 65.2477 118.261 55.3958C118.286 45.5489 126.268 37.6654 136.173 37.7102C145.91 37.7549 153.749 45.7428 153.724 55.5946ZM136.015 65.6602C141.495 65.6453 146.088 61.0524 146.123 55.5499C146.163 49.9977 141.51 45.3153 135.965 45.3302C130.485 45.3451 125.892 49.938 125.857 55.4356C125.818 60.9779 130.48 65.6752 136.01 65.6602H136.015Z",
    fill: "url(#paint4_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8086 133.187C77.7095 135.086 78.0316 137.477 77.4419 139.823C75.8613 146.116 70.1779 150.137 63.7265 149.511C57.6566 148.924 52.6669 143.62 52.4489 137.357C52.325 133.818 52.3201 130.264 52.4489 126.725C52.5629 123.623 54.1485 121.362 56.9629 119.99C57.7408 119.612 58.2116 119.602 58.7368 120.477C60.253 123.002 62.6314 124.096 65.5103 124.125C68.622 124.155 71.7338 124.125 74.8455 124.135C76.8572 124.145 77.7541 124.99 77.8036 126.998C77.8532 128.902 77.8135 130.806 77.8135 133.182L77.8086 133.187Z",
    fill: "url(#paint5_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4183 103.8C66.64 103.8 70.8666 103.785 75.0882 103.8C84.2401 103.834 90.3496 112.767 87.0942 121.326C86.8316 122.017 86.5591 122.474 85.7464 122.057C85.6523 122.007 85.5482 121.967 85.4491 121.957C82.8131 121.679 80.2117 121.401 77.972 119.666C77.1198 119.005 75.881 119.035 74.7562 119.04C71.6941 119.05 68.6319 119.055 65.5697 119.04C63.7314 119.03 62.562 118.041 62.5521 116.52C62.5422 114.999 63.7116 113.999 65.5399 113.97C66.9174 113.946 67.6062 113.239 67.6062 111.847C67.6062 108.562 67.4278 108.407 64.1724 108.959C61.3678 109.431 59.3016 110.923 58.1719 113.562C57.8894 114.223 57.5426 114.551 56.8687 114.74C53.4547 115.684 50.8385 117.688 49.1042 120.804C48.8317 121.296 48.5493 121.639 47.9001 121.605C46.5127 121.53 45.1551 121.788 43.8816 122.315C43.1879 122.604 42.9501 122.35 42.6875 121.798C41.86 120.093 42.3505 118.239 44.0055 117.245C44.9519 116.674 45.9429 116.147 46.9686 115.759C48.138 115.317 48.138 114.73 47.588 113.761C46.81 112.384 46.1312 110.952 45.4425 109.521C43.951 106.419 45.5465 103.819 48.9556 103.81C53.4448 103.795 57.9291 103.81 62.4183 103.81V103.8Z",
    fill: "url(#paint6_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.522 101.081C138.522 108.273 138.492 115.471 138.552 122.663C138.562 123.846 138.265 124.174 137.075 124.155C133.468 124.1 133.468 124.155 133.468 120.541C133.468 107.001 133.493 93.4557 133.433 79.9156C133.428 78.494 133.746 78.0715 135.163 78.32C136.218 78.5089 137.893 77.977 138.279 78.5089C138.839 79.2843 138.517 80.7208 138.522 81.874C138.532 88.2763 138.527 94.6735 138.527 101.076L138.522 101.081Z",
    fill: "url(#paint7_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.284 124.12C146.951 123.961 144.795 124.845 143.874 123.782C143.076 122.867 143.611 120.765 143.611 119.184C143.596 112.831 143.631 106.479 143.581 100.126C143.571 99.0675 143.779 98.6401 144.944 98.6848C147.476 98.7743 150.008 98.7395 152.545 98.6997C153.382 98.6848 153.784 98.8439 153.749 99.8082C153.68 101.767 153.699 103.725 153.744 105.684C153.759 106.444 153.571 106.782 152.743 106.921C150.261 107.334 148.695 109.133 148.675 111.425C148.655 113.651 150.246 115.486 152.738 115.943C153.551 116.092 153.764 116.41 153.744 117.181C153.699 119.139 153.694 121.098 153.744 123.056C153.764 123.881 153.521 124.179 152.679 124.145C151.311 124.08 149.934 124.13 148.288 124.13L148.284 124.12Z",
    fill: "url(#paint8_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8132 131.75C82.8132 130.428 82.8578 129.101 82.7983 127.784C82.7537 126.854 83.056 126.551 83.9776 126.74C86.2123 127.207 87.9614 129.434 87.9267 131.835C87.892 134.166 86.1528 136.323 83.9677 136.761C83.2244 136.91 82.7587 136.835 82.8033 135.876C82.8627 134.504 82.8181 133.127 82.8181 131.75H82.8132Z",
    fill: "url(#paint9_linear_75_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3997 131.914C47.3997 133.231 47.3651 134.548 47.4146 135.866C47.4493 136.795 47.0182 136.915 46.2502 136.75C44.0353 136.278 42.2366 133.992 42.2763 131.67C42.3209 129.389 44.0948 127.207 46.2551 126.754C47.0232 126.59 47.4493 126.715 47.4146 127.649C47.3651 129.071 47.3997 130.492 47.3997 131.919V131.914Z",
    fill: "url(#paint10_linear_75_382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_382",
    x1: 65.0445,
    y1: 93.6006,
    x2: 65.0445,
    y2: 174.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_382",
    x1: 65.0418,
    y1: 24.9971,
    x2: 65.0418,
    y2: 88.5554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_382",
    x1: 141.049,
    y1: 139.355,
    x2: 141.049,
    y2: 164.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_382",
    x1: 65.0772,
    y1: 153.481,
    x2: 65.0772,
    y2: 174.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_382",
    x1: 135.993,
    y1: 37.71,
    x2: 135.993,
    y2: 73.2854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_382",
    x1: 65.0913,
    y1: 119.746,
    x2: 65.0913,
    y2: 149.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_382",
    x1: 65.1362,
    y1: 103.793,
    x2: 65.1362,
    y2: 122.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_382",
    x1: 136.022,
    y1: 78.2529,
    x2: 136.022,
    y2: 124.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_382",
    x1: 148.593,
    y1: 98.6816,
    x2: 148.593,
    y2: 124.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_382",
    x1: 85.3606,
    y1: 126.687,
    x2: 85.3606,
    y2: 136.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_382",
    x1: 44.8461,
    y1: 126.693,
    x2: 44.8461,
    y2: 136.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 150,
    fill: "white",
    transform: "translate(27 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehavioralBiometrics);
export default __webpack_public_path__ + "static/media/Behavioral_Biometrics.d58237da10030e810ced9a627e05b82e.svg";
export { ForwardRef as ReactComponent };